module.exports = __webpack_public_path__ + "img/event_placeholder.5a0753db.jpg";